import React, { useEffect, useState } from "react";
import { Form } from "react-router-dom";
import TextEditor from "./TextEdit";
import CloseIcon from '@mui/icons-material/Close';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import YouTubeEmbedder from "./YouTubeEmbedder";
import FileUpload from "./FileUpload";

export default function CreateArea(props) {
    const { onAdd, updateOpen, isOpen, setOpen, target, addBlockToGroup, groups, 
      editGroupTitle, editBlock, skin, highlightColors } = props;
  const coverStyle = {
    width: "100vw"
  } 
  const leftStyle = {
    left: "0",
    width: window.innerWidth >= 830 ? "55vw" : window.innerWidth >= 600 ? "80vw" : "100vw",
    margin: "0 5vw 0 0"
  }
  const rightStyle = {
    right: "0",
    width: window.innerWidth >= 830 ? "55vw" : window.innerWidth >= 600 ? "80vw" : "100vw",
    margin: "0 0 0 5vw"
  }
  const leftClose = {
    left: "0",
    width: "0",
    overflow: "hidden"
  }
  const rightClose = {
    right: "0",
    width: "0",
    overflow: "hidden"
  }
  const optionsLeft = {
    right: "30px",
  }
  const optionsRight = {
    left: window.innerWidth >= 600 ? "30px" : "15px",
    flexDirection: "row-reverse"
  }
  
  const [whichSide, setSide] = useState(false);
  const [group, setGroup] = useState(
    { title: "", blockTitle: "", blockContent: "", blockRetract: "unretractable" }
  );
  const [blockType, setBlockType] = useState("text");
  const [confirmingClose, setConfirmingClose] = useState(false);
  const [switching, setSwitching] = useState(false);

  useEffect(() => {// Reset form only when closing, not when switching sides 
    if (isOpen) {
      setGroup({ title: "", blockTitle: "", blockContent: "", blockRetract: "unretractable" });
      setBlockType("text");
    }
  }, [isOpen]);

  useEffect(() => {//are you sure you want to reload etc
    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = '';
    };

    if (isOpen) {
      window.addEventListener('beforeunload', handleBeforeUnload);
    } else {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    }

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [isOpen]);

  function handleClose() {
    if (target.method === "addGroup") {
      const total = group.blockTitle + group.blockContent + group.title;
      if (total.length !== 0) {
        setConfirmingClose(true);
      } else {
        updateOpen()
      }
    } else if (target.method === "editGroup") {
      if (group.title !== groups[target.groupOrder]?.title) {
        setConfirmingClose(true);
      } else {
        updateOpen();
      }
    } else if (target.method === "addBlock") {
      const total = group.blockTitle + group.blockContent;
      if (total.length !== 0) {
        setConfirmingClose(true);
      } else {
        updateOpen()
      }
    } else if (target.method === "editBlock") {
      if (group.blockTitle !== groups[target.groupOrder]?.blocks[target.blockOrder]?.title ||
        group.blockContent !== groups[target.groupOrder]?.blocks[target.blockOrder]?.content) {
        setConfirmingClose(true);
      } else {
        updateOpen();
      }
    }
  }

  function updateSide() {
    setTimeout(() => {
      setSwitching(true);
    }, 10);
    
    setTimeout(() => {
      setSide((prevVal) => !prevVal);
    }, 200);
    
    setTimeout(() => {
      setSwitching(false);
    }, 350);
  }

  useEffect(() => { // Prefill inputs
    if (target.method === "editGroup") {
      setGroup((prevGroup) => ({
        ...prevGroup,
        title: groups[target.groupOrder]?.title,
      }));
    } else if (target.method === "editBlock") {
      setGroup((prevGroup) => ({
        ...prevGroup,
        title: groups[target.groupOrder]?.title,
        blockTitle: groups[target.groupOrder]?.blocks[target.blockOrder]?.title,
        blockContent: groups[target.groupOrder]?.blocks[target.blockOrder]?.content,
        blockRetract: groups[target.groupOrder]?.blocks[target.blockOrder]?.retract,
      }));
      setBlockType(groups[target.groupOrder]?.blocks[target.blockOrder]?.type)
    } else if (target.method === "addBlock") {
      setGroup((prevGroup) => ({
        ...prevGroup,
        title: groups[target.groupOrder]?.title,
      }));
    }
  }, [groups, target]);

  function handleBlockTypeChange(type) {
    if (blockType !== type) {
      setGroup(prevGroup => ({ ...prevGroup, blockContent: "" }));
      setBlockType(type);
    }
  }

  function handleChange(event) {
    const { name, value } = event.target;
    setGroup(prevGroup => ({ ...prevGroup, [name]: value }));
  }

  function formatTime(date) {
    return date.toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }).replace(",", " at");
  }

  function submit(event) {
    const total = group.blockTitle + group.blockContent + group.title;
    if(total.length === 0 && target.method !== "editGroup") return;
    if(group.blockContent.length === 0 && blockType !== "text") return;
    setOpen(false);
    if (target.method === "editGroup") {
      editGroupTitle(target.groupId, target.groupOrder, group.title);
    } else if (target.method === "editBlock") {
      editBlock(target.groupId, target.groupOrder, target.blockId, target.blockOrder, blockType, group.blockRetract, group.blockTitle, group.blockContent);
    }
    if (total.length !== 0) {
      if (target.method === "addGroup") {
        const block1Total = group.blockTitle + group.blockContent;
        const now = new Date();
        const newContent = {
          id: target.groupId,
          order: target.groupOrder,
          title: group.title,
          timeCreated: formatTime(now),
          blocks: block1Total.length !== 0 ? [{id: 0, order: 0, type: blockType, retract: group.blockRetract, title: group.blockTitle, content: group.blockContent, columnStart: skin.columnStart,
            columnEnd: skin.columnEnd }] : [],
        };
        onAdd(newContent);
      } else if (target.method === "addBlock") {
        if((group.blockTitle + group.blockContent).length !== 0){
          if (target.groupId !== null) {
            addBlockToGroup(target.groupId, target.groupOrder, target.blockId, target.blockOrder, blockType, group.blockRetract, group.blockTitle, group.blockContent);
          }
        }
      }
    }
    event.preventDefault();
  }

  return (
    <div>
      <div id="screen-cover" style={isOpen? coverStyle : null}>
        {confirmingClose? 
        <div id="close-confirm">
          <h2>are you sure you want to cancel this?</h2>
          <div>
          <button className="block-type-option" onClick={() => {
            updateOpen()
            setConfirmingClose(false)
          }}>
            OK
          </button>
          <button className="block-type-option" onClick={() => setConfirmingClose(false)}>Cancel</button>
          </div>
        </div>
        : null}
        <div id="create-container" style={isOpen && !switching? whichSide? leftStyle : rightStyle : whichSide? leftClose : rightClose}>
          <div id="create-area-options" style={whichSide? optionsLeft : optionsRight}>
            <SwapHorizIcon id="create-area-swap-sides" onClick={updateSide}/>
            <CloseIcon onClick={handleClose}/>
          </div>
          <Form id="create-block">
            <div className="create-input">
              <input
                name="title"
                onChange ={handleChange}
                value={group.title}
                placeholder="group title"
                readOnly={target.method === "addBlock" || target.method === "editBlock"? true : false}
              />
            </div>
            {(target.method === "addGroup" || target.method === "addBlock") && <div id="block-type">
                <div className="block-type-option" onClick={() => {handleBlockTypeChange("text")}} id={blockType === "text"? "block-type-selected" : null}>text</div>
                <div className="block-type-option" onClick={() => {handleBlockTypeChange("image")}} id={blockType === "image"? "block-type-selected" : null}>image</div>
                <div className="block-type-option" onClick={() => {handleBlockTypeChange("video")}} id={blockType === "video"? "block-type-selected" : null}>video</div>
                <div className="block-type-option" onClick={() => {handleBlockTypeChange("pdf")}} id={blockType === "pdf"? "block-type-selected" : null}>pdf</div>
                <div className="block-type-option" onClick={() => {handleBlockTypeChange("audio")}} id={blockType === "audio"? "block-type-selected" : null}>audio</div>
            </div>}
            {target.method !== "editGroup" && <div className="create-input">
              <input
                name="blockTitle"
                onChange={handleChange}
                value={group.blockTitle}
                placeholder="block title"
              />
            </div>}
            {target.method !== "editGroup" && <div className="create-input">
              {isOpen && blockType === "text"? 
                <TextEditor
                    setGroup={setGroup}
                    realContent={target.method === "editBlock" ? group.blockContent : ""}
                    isOpen={isOpen}
                    skin={skin}
                    highlightColors={highlightColors}
                /> : null
              }
              {blockType === "image"?
                <FileUpload group={group} setGroup={setGroup} type="image"/> : null
              }
              {blockType === "video"? 
                <YouTubeEmbedder setGroup={setGroup} realContent={group.blockContent} isOpen={isOpen}/>
                :null
              }
              {blockType === "pdf" && (
                <FileUpload group={group} setGroup={setGroup} type="pdf"/>
              )}

              {blockType === "audio" && (
                <FileUpload group={group} setGroup={setGroup} type="audio"/>
              )}
            </div>}
            {target.method !== "editGroup" && <select name="blockRetract" onChange ={handleChange} value={group.blockRetract} >
              <option value="unretractable" >Unretractable</option>
              <option value="autoretract">Retract automatically</option>
              <option value="retractable">Retractable</option>
            </select>}
            <button id="submit-button" onClick={submit}>Submit</button>
            <div id="space" />
          </Form>
        </div>
      </div>
    </div>
  );
}